export default "__VITE_ASSET__LXkSMmcz__"